import { apiSlice } from '../api/apiSlice';
import {
  CheckoutParams,
  CheckoutResponse,
  HistoryParams,
  HistoryResponse,
  PaymentParams,
  PaymentResponse,
} from './topUpApiSliceTypes';

const orderApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    topUpCheckout: builder.mutation<CheckoutResponse, CheckoutParams>({
      query: (params) => ({
        url: '/topups/checkout',
        method: 'POST',
        body: {
          esimId: params.esimId,
          packageId: params.packageId,
          amount: params.amount,
        },
      }),
    }),

    payment: builder.mutation<PaymentResponse, PaymentParams>({
      query: (params) => ({
        url: '/topups/payment',
        method: 'POST',
        body: {
          amount: params.amount,
          deviceType: 'web',
          esimId: params.esimId,
          packageId: params.packageId,
        },
      }),
    }),

    getTopUpHistory: builder.query<HistoryResponse, HistoryParams>({
      query: (params) => ({
        url: '/topups/history',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useTopUpCheckoutMutation,
  usePaymentMutation,
  useGetTopUpHistoryQuery,
  useLazyGetTopUpHistoryQuery,
} = orderApiSlice;
